import { afterNextRender, ChangeDetectionStrategy, Component, ElementRef, inject, output, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SportsbookFacadeService } from '../sportsbook/sportsbook-facade.service';

@Component({
  selector: 'app-match-search-mobile-panel',
  imports: [TranslateModule],
  templateUrl: './match-search-mobile-panel.component.html',
  styleUrl: './match-search-mobile-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchSearchMobilePanelComponent {
  readonly dismissed = output<void>();
  protected readonly sportsbook = inject(SportsbookFacadeService);
  private readonly searchInput = viewChild.required<ElementRef<HTMLInputElement>>('searchInput');

  constructor() {
    afterNextRender(() => this.searchInput().nativeElement.focus({ preventScroll: true }));
  }

  protected onInput(event: Event): void {
    this.sportsbook.setSearchQuery((event.target as HTMLInputElement).value);
  }

  protected clear(): void {
    this.sportsbook.setSearchQuery('');
    this.searchInput().nativeElement.focus({ preventScroll: true });
  }

  protected dismiss(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.dismissed.emit();
  }
}
